import React, { useState, useEffect } from "react";
import { Layout, Menu, Card, Button, Drawer } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { API_BASE_URL } from "../../Config";
import "./DictionaryPage.css";
import AdvertisementCard from "../AdvertisementCard";

const { Sider, Content } = Layout;
const { SubMenu } = Menu;

const DictionaryPage = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedSection, setSelectedSection] = useState("category");
  const [allYogaPages, setAllYogaPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeKey, setActiveKey] = useState(null);
  const [mobile, setMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const resize = () => setMobile(window.innerWidth < 900);
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/allpages?page=dictionary`);
        const data = res.data?.data || [];

        setAllYogaPages(data);

        if (data.length > 0) {
          setSelectedLanguage(data[0]);
          setSelectedSection("category");
          setActiveKey(`${data[0]._id}-category`);
        }
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, []);

  const getSelectedContent = () => {
    if (!selectedLanguage) {
      return "<p>Please select a category from the left.</p>";
    }

    return selectedSection === "category"
      ? selectedLanguage.categoryContent
      : selectedLanguage.alphabetContent;
  };

  const menuItems = allYogaPages.map((lang) => ({
    key: lang._id,
    label: lang.yogaType,
    children: [
      {
        key: `${lang._id}-category`,
        label: "Category",
        onClick: () => {
          setSelectedLanguage(lang);
          setSelectedSection("category");
          setActiveKey(`${lang._id}-category`);
        },
      },
      {
        key: `${lang._id}-alphabet`,
        label: "Alphabet",
        onClick: () => {
          setSelectedLanguage(lang);
          setSelectedSection("alphabet");
          setActiveKey(`${lang._id}-alphabet`);
        },
      },
    ],
  }));

  const renderMenu = (isMobileMenu = false) => (
    <Menu
      mode="inline"
      selectedKeys={activeKey ? [activeKey] : []}
      items={menuItems.map((lang) => ({
        key: lang.key,
        label: lang.label,
        children: lang.children.map((child) => ({
          key: child.key,
          label: child.label,
          onClick: () => {
            child.onClick();
            if (isMobileMenu) setDrawerOpen(false); // close drawer
          },
        })),
      }))}
    />
  );

  if (mobile) {
    return (
      <>
        {/* Languages Button */}
        <div
          style={{
            padding: "90px 16px 16px",
          }}
        >
          <Button
            style={{
              background: "#1f2937",
              color: "#fff",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
            onClick={() => setDrawerOpen(true)}
          >
            ☰ Languages
          </Button>

          {loading ? (
            <h2>Loading...</h2>
          ) : (
            <Card style={{ borderRadius: "12px", padding: "16px" }}>
              <div
                className={`page-content ${
                  selectedSection === "alphabet" ? "alphabet-view" : ""
                }`}
                dangerouslySetInnerHTML={{
                  __html: getSelectedContent(),
                }}
              />
            </Card>
          )}
        </div>

        {/* Drawer */}
        <Drawer
          title="Languages"
          placement="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          width={260}
          bodyStyle={{ padding: 0 }}
        >
          <Menu
            mode="inline"
            selectedKeys={activeKey ? [activeKey] : []}
            items={menuItems.map((lang) => ({
              key: lang.key,
              label: lang.label,
              children: lang.children.map((child) => ({
                key: child.key,
                label: child.label,
                onClick: () => {
                  child.onClick();
                  setDrawerOpen(false);
                },
              })),
            }))}
          />
        </Drawer>
      </>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider
          width={250}
          style={{
            height: "900px",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Languages
          </div>

          <Menu
            mode="inline"
            className="dictionary-menu"
            selectedKeys={activeKey ? [activeKey] : []}
            items={menuItems}
          />
        </Sider>

        <Content style={{ padding: "30px" }}>
          {loading ? (
            <h2>Loading...</h2>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedLanguage?.yogaType}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <Card style={{ borderRadius: "12px", padding: "24px" }}>
                  <div
                    className={`page-content ${
                      selectedSection === "alphabet" ? "alphabet-view" : ""
                    }`}
                    dangerouslySetInnerHTML={{
                      __html: getSelectedContent(),
                    }}
                  />
                </Card>
              </motion.div>
            </AnimatePresence>
          )}
        </Content>
      </Layout>
      <AdvertisementCard />
    </motion.div>
  );
};

export default DictionaryPage;
